import React from 'react';
import { Box } from '@mui/material';
import { LineChart } from '@mui/x-charts/LineChart';

/**
 * StackedAreaWidget - Renders a stacked area chart for multi-series time data
 * 
 * @param {Array} data - Array of data points with seriesName, xLabel, and yValue
 * @param {Object} config - Widget configuration (title, description, etc.)
 */
export default function StackedAreaWidget({ data, config, height = 300 }) {
  // Group data by series
  const seriesMap = {};
  const xLabelsSet = new Set();
  
  data.forEach(item => {
    if (!seriesMap[item.seriesName]) {
      seriesMap[item.seriesName] = {};
    }
    seriesMap[item.seriesName][item.xLabel] = parseFloat(item.yValue);
    xLabelsSet.add(item.xLabel);
  });

  // Get unique x-axis labels in order
  const xLabels = Array.from(xLabelsSet);

  // Create series data
  const series = Object.keys(seriesMap).map((seriesName, index) => {
    const colors = ['#1976d2', '#dc004e', '#ff9800', '#4caf50', '#9c27b0'];
    return {
      data: xLabels.map(label => seriesMap[seriesName][label] || 0),
      label: seriesName,
      area: true,
      stack: 'total',
      showMark: false,
      color: colors[index % colors.length],
    };
  });

  return (
    <Box>
      <LineChart
        xAxis={[{ 
          scaleType: 'point', 
          data: xLabels 
        }]}
        series={series}
        height={height}
        margin={{ top: 10, right: 10, bottom: 30, left: 50 }}
      />
    </Box>
  );
}
